// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"14ad2131","56":"d2fc857f","85":"128a8acc","240":"0c382e0d","276":"9040ab54","353":"116079fb","453":"53be9442","465":"79055bbc","634":"03f07701","645":"5f203339","654":"683a9a14","660":"d0e87ad1","661":"85c7dc95","697":"4fb1f22e","712":"789222e4"}[chunkId] + ".chunk.js";
};